import { render } from "./OtherFacilitiesList.vue?vue&type=template&id=384914ca&scoped=true"
const script = {}

import "./OtherFacilitiesList.vue?vue&type=style&index=0&id=384914ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-384914ca"

export default script